module.exports = __webpack_public_path__ + "static/media/stikke.48545a77.m4a";